import { useContext } from "react";

import { PermissionContext } from "./index";

export function usePermissionContext() {
  return useContext(PermissionContext);
}
